import { render, staticRenderFns } from "./locationInfo.vue?vue&type=template&id=238b6006&scoped=true"
import script from "./locationInfo.vue?vue&type=script&lang=js"
export * from "./locationInfo.vue?vue&type=script&lang=js"
import style1 from "./locationInfo.vue?vue&type=style&index=1&id=238b6006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b6006",
  null
  
)

export default component.exports